import api from "../../client";

export type DegreesResponseData = string[];

export interface ApiResponse<T> {
  success: boolean;
  message: string;
  data: T;
}

export const getDegreesRequest = async (): Promise<DegreesResponseData> => {
  const { data } = await api.get<ApiResponse<DegreesResponseData>>(
    "/profile/enums/degrees",
  );
  return data.data;
};
